import { createActionCreator, createReducer } from 'deox';
import { PremiumData } from '../components/header/OneTimePayAccordion';
import { AppState } from 'types/AppState';
import { OneTimePayment, UserPaidItems } from 'types/UserPaidItems';

const defaultState: OneTimePayment = {
  userPaidItems: [],
  recentlyPaidItems: [],
  paymentStatus: false
};

export const setUserPaidItems = createActionCreator(
  'USER_PAID_ITEMS/SET_USER_PAID_ITEMS',
  resolve => (userPaidItems: UserPaidItems[], recentlyPaidItems?: PremiumData[]) =>
    resolve({ userPaidItems, recentlyPaidItems })
);

export const loadUserPaidItems = createActionCreator(
  'USER_PAID_ITEMS/LOAD_USER_PAID_ITEMS',
  resolve => (recentlyPaidItems?: PremiumData[]) => resolve(recentlyPaidItems)
);
export const setOneTimePaymentReset = createActionCreator('USER_PAID_ITEMS/RESET');

export const oneTimePayment = createReducer(defaultState, handle => [
  handle(setUserPaidItems, (state, { payload: { userPaidItems, recentlyPaidItems } }) => ({
    ...state,
    userPaidItems,
    recentlyPaidItems: recentlyPaidItems ?? state.recentlyPaidItems,
    paymentStatus: !!recentlyPaidItems
  })),
  handle(setOneTimePaymentReset, state => ({
    ...state,
    paymentStatus: false,
    recentlyPaidItems: []
  }))
]);

export const getUserPaidItems = (state: AppState): UserPaidItems[] =>
  state.oneTimePayment.userPaidItems;
export const getOneTimePaymentStatus = (state: AppState): boolean =>
  state.oneTimePayment.paymentStatus;
export const getOneTimeRecentPaidItems = (state: AppState): PremiumData[] =>
  state.oneTimePayment.recentlyPaidItems;
